import jaLocale from 'element-ui/lib/locale/lang/ja'
const jp = {
login:{
buttoo:{
    add:'add'
}
},
dialog:{
buttton:{
    close:'閉じる'
},
ReportError:{
  next:'次へ',
 h1:'エラーレポートはユーザーがデータ問題を解決し、データの品質を向上させるために私たちとコミュニケーションを行うことができる。',
 li1:'データに関する問題や質問がある場合 ',
 li2:'このデータを改善するために会社情報を提供したい場合 ',
 li3:'プライベートと考える可能性がある企業情報を開示しないことを選択した場合 ',
 li4:'サービスを改善するための建設的な提案がある場合 ',
 h2:"提出されたすべてのコメントはデータ検証の対象である。ユーザーは独自のユーザープロフィールを完了しなければならない。 当社の代表者は,あなたの会社を代表する権利を認証し、確認するためにあなたに連絡することができる。"
},
},
Home:{
    Applications:'アプリケーション',
  SearchCompanies:'会社検索',
  SearchTrade:'貿易検索',
  SearchRisks:'リスク検索',
  SearchCountries:'国検索',
  SearchNews:'ニュース検索',
  SearchLeads:'リーズ検索',
 selectCountry:'国選択',
 inputCompany:'会社名',
 keWord:'キーワード',
 firstWord:"文字（左から）",
searchCompanyNum:"200以上の国や地域で5億社以上の企業を検索する",
 search:'検索',
 homeSeachTitle:'グローバルビジネスに注目する',
 homeTitleDetail:'CSIはデータクレジット、リスク管理、ビッグデータを専門としたデータ主導の研究及びIT会社である。全世界の投資家と管理者にデジタルツールを提供し、経験的なデータチームを活用し、アルゴリズム、モデル、深いデータ分析より、直感的なプラットフォームを作成する。CSIは信頼性が高く、即時に提供する',
 phoneTitleDetail:'会社情報を速く検索、表示、取得するには、携帯電話でCSIアプリを使用することもできる。',
IndustryAnalysis :'業界分析',
BusinessAnalytics :'ビジネス分析',
ImportExportData :'データのインポートとエクスポート',
CompanyNews :'社内ニュース',
Sanctions :'制裁',
SearchLeads:"潜在顧客の検索",
BusinessIntelligence :'ビジネスインテリジェンス',
CompanyIdentityVerification :'会社識別認証',
KYCSolutions :'KYCソリューション',
OwnershipPenetration :'所有権の浸透',
CompanyFinancialAnalysis:'会社財務分析',
CreditRatings :'与信レベル',
CreditReports :'与信レポート',
ESGRatings :'ESG評価',
VendorScreening :'ベンダー選定',
MarketResearch:'市場調査' 
},

IndustryStatistics:{
    SubjectCompany:"対象会社",
    Country:"国",
    Compare:"比較",
    Industry:"産業",
    CompanyType:"会社類型",
    CompanySize:"会社規模",
    CompanyStatus:"会社状況",
    YearsinBusiness:"ビジネス年数",
    CompanyRating:"会社レベル"
},
ListofResults:{
  SelectCountry:'国選択',
  ClearAll:'全削除',
  SelectIndustry:'業界選択',
  ListedCompany:'上場会社',
  YearsinBusiness:'営業年数',
  Sharethisinformation:'情報を共有する',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'1つ以上のメールアドレスを入力してください',
  Example:'例',
  message:'メッセージ',
  pleaseleaveamessage:'メッセージを残してください',
  Include:'含む',
  thisaddress:'会社名、ID、住所',
  CSIwebsite:'CSIウェブサイト',
  Update:'更新',
  Iftheavailable:'利用可能なオンラインデータが不十分または古くなった場合は、「更新」ボタンをクリックして、当社のローカルネットワーク調査員またはクレジットレポート機関から新しい調査されたビジネスクレジットレポートの即時更新を要求することができる。この更新の費用は会社ごとに1クレジットである。更新レポートは通常24時間から72時間までかかる。',
  Abusinesscredit :'ビジネスクレジットレポートは、対象会社の識別データ、登録記録、株主構造、会社歴史、経営説明、関連会社、実際の運営、貿易参照、財務データと分析、訴訟記録と制裁などの公式公開情報、信用分析と評価に関する詳細な情報を提供する。',
  Searchcompanies:'他の企業のメールを検索する',
  Rowsperpage:'ページごとの行数'

},
AiZaba:{
whatareyousearchingfor:'何を探していますか。',
CreditAnalyst:'与信分析',
Assesses:"会社の信用価値を評価し、財務リスクを特定し、データ分析と信用評価を通じて安全な取引を確保する。",
LegalAdvisor:"法律顧問",
Provides:'コンプライアンスガイダンスを提供し、契約を審査し、ビジネス運営が法律に準拠し、紛争を避けるためにリスクを評価する。',
BizConsultant:'ビジネスコンサルタント',
Optimizes:'サプライチェーンを最適化し、購入者を識別し、市場の傾向を分析し、効率を向上させるためのカスタマイズされた戦略を提供することによって販売を高める。',
EconomicAnalyst:'貿易分析（中）経済アナリスト（英）',
Analyzes:"業界と地域経済の傾向を分析し、ビジネスが情報ある決定を下し、競争力を維持する。"
},
Toolbar:{
    Filter:"フェルター",
    Select:"選択",
    Edit:"編集",
    Sortby:"ソート順",
    Collect:"コレクト",
    Saved:"保管",
    Compare:"比較",
    Export:"輸出",
    Download:"ダウンロード",
    Update:"アップデート",
    Reporterror:"エラー報告",
    Share:"シェア",
     ascending:'昇順',
    descending:'降順',
    Customfolder:'カスタムフォルダ'
},
ContentTabs:{
    Background:"背景",
    BusinessActivities:"ビジネス活動",
    Performance:"パフォーマンス",
    Publications:"出版物",
    CreditOpinion:"与信意見",
    MarketAnalysis:"市場分析",
    Snapshot:"スナップショット",
    Profile:"概要",
    Ownership:"所有権",
    RelatedCompanies:"関連会社",
    Management:"管理",
    Operations:"活動",
    Locations:"所在地",
    Industry:"業界",
    ImportExport:"輸入＆輸出",
    SupplyChain:"サプライチェーン",
    FinancialHighlights:"財務概要",
    RatioAnalysis:"比率分析",
    IndustryNorm:"業界標準",
    News:"ニュース",
    Sanctions:"制裁",
    IndustryStatistics:"業界統計",
    RatingAnalysis:"評価分析",
    CompetitiveAnalysis:"競争分析",
    Lawsuits:"提訴"
},
navigationBar:{
Notifications:'通知',//通知
MarkasRead:'既読',//标记已读
Viewall:'全表示',//查看全部
SilverSubscriber:'シルバー会員',//银级用户
Silversubscriberdate:'シルバーロック有効期限',//银级到期日
GoldSubscriber:'ゴールド会員',//金级用户
Goldsubscriptiondate:'ゴールドロック有効期限',//金级到期日
AvailableCredits:'利用可能なクレジット',//可用积分
AddCredits:'クレジット追加',//购买积分
IndivdualAccount:'個人口座', //个人账号
GroupAccount:'集団口座' //集团账号

},
Snapshot:{
    CompanyDQIdesc:"データ品質指数 (DQI) は、完全性、有効性、ソースの信頼性、一致性、タイムリンシュ、両言語サポートなど、データのさまざまな側面を評価するためにアルゴリズムを使用する。このインデックスは、データの質を1から100のスケールで評価するために設計され、より高いスコアは優れたデータの質を示してる。アルゴリズムは、事前に定義されたルールや基準に基づいてデータを分析することができ,客観的で標準化された測定を可能になる。 当社のデータ品質指数（DQI）は信頼性の高い指標として機能し、ユーザーがデータの品質を定量的に評価することができる。これにより、データに基づく意思決定が可能になり、データの全体的な価値と有用性が高まる。",
  CountryDQIdesc:"データ品質指数（DQI）は、各国間のデータの信頼性、正確性、アクセシビリティを評価し、デジタルインフラ、ガバナンス、透明性の違いを反映する。先進国は通常、強力なデータシステム、オープンな政策、先進テクノロジーにより、より高いランキングを得ている一方、開発途上国はインフラ、規制、データ共有の実践におけるギャップに苦しんでいる。 主要な要因には、政府の透明性、データ保護法、技術の採用が含まれている。高いDQIは、より良い政策決定とビジネス決定を可能にする一方、低いスコアは、資が必要な領域を強調する。",
  CompanyDQI:'会社DQI',//公司数据质量指数 DQI
  CountryDQI:'国DQI',//国家数据质量指数 DQI
  Address:'アドレス',//地址
  CountyCity:'国/市',//县/市
  ProvinceState:'省/州',//省/州
  CountryRegion:'郡/区',//国家/地区
  ZipCode:'郵便番号',//邮政编码
  Website:'ウェブサイト',//网站
  Email:'メール',//电邮
  Tel:'電話',//电话
  LastUpdate:'最後の更新',//最近更新
  DataSource:'データソース',//数据来源
  LegalStatus:'法律状況',//法定状况
  CoID:'ID',//公司ID
  CompanyType:'会社種類',//公司类型
  RegistrationDate:'登録日',//注册日期
  RegistrationStatus:'登録状況',//注册状态
  Listed:'上場状況',//上市信息
  CurrentOpperations:'ビジネス状況',//经营状况
  IndustryCode:'業界コード',//行业代码
  BusinessActivities:'主要業務',//主营业务
  NoofEmployees:'従業員人数',//员工数量
  NoofShareholders:'株主数',//股东数量
  Management:'管理状況',//管理状况
  Performance:'業務状況',//业绩表现
  Revenue:'収入',//收入
  Assets:'資産',//资产
  ProfitLoss:'利益',//利润
  Growth:'会社成長',//公司增长
  Competitiveness:'競争力',//竞争力
  CreditOpinion:'与信状況',//信用状况
  CreditRating:'与信レベル',//信用评级
  CreditScore:'与信点数',//信用评分
  ESGRating:'ESGレベル',//ESG 评级
  Solvency:'ソルベンシー',//偿还能力
  Sanctions:'グローバル制裁',//全球制裁

},
Profile:{
  CompanyProfile:'会社概要',//基本资料
  CompanyName:'会社名',//公司名称
  NativeName:'ネイティブ名',//当地名称
  CompanyID:'会社ID',//公司 ID
  VATNumber:'VAT番号',//VAT号
  StockCode:'株式コード',//股票代码
  Listed:'上場',//上市日期
  RegistrationDate:'登録日',//注册日期
  LegalForm:'会社種別（中）法律形式（英）',//公司性质
  CompanyType:'会社種類',//公司类型
  LegalStatus:'法律状況',//注册状态
  Jurisdiction:'管轄権',//司法管辖区
  RegisteredAddress:'登録アドレス',//注册地址
  ProvinceState:'省/州',//省/州
  CountryRegion:'郡/区',//国家/地区
  ZipCode:'郵便番号',//邮政编码
  OperatingAddress:'経営アドレス',//经营地址
  LastUpdate:'最後の更新',//最近更新
  DataSource:'データソース',//数据来源
  History:'歴史',//历史记录
    RegisteredCapital:'登録資本金',
  PaidinCapital:'実際資本金',
  CountyCity:'地区'
},
Ownership:{
 UltimateBeneficiary:'最終利益者',//最终受益人
  InvolvingIndividuals:'関連自然人株主',//涉及自然人股东
  InvolvingEnterprises:'関連法人株主',//涉及法人股东
  ShareholderLevel:'株主レベル',//股东层级x
  Name:'名',//名称
  Country:'国',//国家/地区
  Location:'所在地',//地点
  Type:'種類',//类型
  Shares:'シェア',//股份
  Relation:'関係',//关系
  Individuals :'個人',//关系,
  PartiesInvolved:'関連者',
  RelatedCompany:'関連会社',
  CompanyShareholders:'会社株主',
  NGOShareholders:'NGO株主',
  NaturalPersonShareholder:'自然人株主',
  SubjectInvestments:'主体投資'
  
},
RelatedCompanies:{
 Total:'会社概要',//相关公司总计
  Entities:'会社名',//法人实体
  Countries:'国',//国家/地区
  Branches:'支店',//分支机构
  RelatedComp:'関連会社',//关联公司
  Name:'名',//名称
  Country:'国',//国家/地区
  Location:'所在地',//地点
  Type:'種類',//类型
  Shares:'Shares',//股份
  Relation:'関係',//关系
  BranchOffices:'支店',
  Individuals:'個人',
},
Management:{
  Total:'管理',//管理层
  ContactInfo:'連絡者',//联系人信息
  Countries:'国',//国家/地区

  Name:'名',//名称
  Position:'職位',//职位
  Department:'部门',//部门
  Country:'国',//国家/地区
  ShareholderNot:'株主かどうか',//是否股东
  Relation:'関係',//关系
  Verification:'検証',//已验证
  Searchmoreemails:'もっとメールを検索する',//搜索更多电邮
  Roles:'役割',//角色
  EducationLevel:'教育レベル',//教育程度
  Phone:'電話',//电话
  Email:'メール',//电邮
  Verified:'確認',//已验证
  Searchmore:'他の会社のメールを検索する',//搜索更多其他公司的电邮
},
Operations:{
    Operations:'運営',
  LineofBusiness:'事業分野',//业务范围
  BusinessTerritories:'ビジネス領域',//业务区域
  ImportExport:'輸入＆輸出',//进出口信息
  Viewtradeinfo:'もっと引取情報を見る',//查看更多贸易信息
  ProductsServices:'製品/サービス',//产品/服务
  Products:'製品',//产品
  ProductImage:'製品イメージ',//产品图片
  ProductName:'製品名',//产品名称
  ProductDescription:'製品紹介',//产品描述
  Details:'詳細',//详情
  Addproductinformation :'製品情報を追加する',//添加产品信息
},
Locations:{
   Locations:"地位",
  CoName:'名',//业务范围
  Relationship:'関係',//关系
  Country:'国',//国家/地区
  Location:'所在地',//地点
  Address:'アドレス',//地址
  Edit:'編集',//编辑
  CompanyLocatiionsMap:'会社所在地の地図',//地图中的公司位置
  Selectaddresstype:'アドレスタイプを選択する',//选择地址类型
  Subjectcompany:'対象会社',//目标公司
  Subsidiary:'子会社',//子公司
  RegisteredAddress :'登録アドレス',//注册地址
  OperationAddress :'営業アドレス',//运营地址
  All :'全部',//全部
},
Industry:{
  IndustryTitle:'業界タイトル',//IndustryTitle
  IndustryDescription:'業界説明',//IndustryDescription
  ISIC:'ISIC',//ISIC
  ISICDescription:'ISIC説明',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'NACE説明',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'NAICS説明',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'CSIC説明',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'AAAIC説明',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'GICS説明',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Total Import Amount',//进口总额
  TopImportCountry:'Top Import Country',//最大进口国家/地区
  TopImportProduct:'Top Import Product',//最大进口产品
  TotalExport:'Total Export',//出口总额
  TopExportCountry:'Top Export Country',//最大出口国家/地区
  TopExportProduct:'Top Export Product',//最大出口产品
  TradeVolume:'Trade Volume',//贸易额
  ImportShipments:'Import Shipments',//进口量
  ExportShipments:'Export Shipments',//出口量
  ImportCountries:'Import Countries',//进口国家/地区
  ExportCountries:'Export Countries',//出口国家/地区
  ImportVolume:'Import Volume',//进口量
  ExportVolume:'Export Volume',//出口量
  TopSuppliers:'Top Suppliers',//主要供应商
  ByNumberofShipments:'運送数量',//按出货量
  TopBuyers:'トップバイヤー',//主要买家
  ByNumberofShipments:'運送数量',//按出货量
  ImportQuantity:'輸入量',//进口数量
  IncreaseDecreasexRate:'増加/減少率',//增/减率
  ExportQuantity:'輸出量',//出口数量
  ImportsExportsRecords:'輸入＆輸出概要',//进出口记录
  Date:'日付',//日期
  Product:'製品',//产品
  HSCode:'HSコード',//HS 编码
  BuyerName:'バイヤー名',//买家名称
  Destination:'目的地',//目的地
  SupplierName:'サプライヤー名',//供应商名称
  Origin:'出発地',//原产地
  Amount:'金額',//金额
  Details:'詳細',//详情
},

FinancialHighlight:{
    ProfitabilityRatios:'収益率',
  OperatingRatios:'運営比率',
  StructuralRatios:'構造比率',
ProductivityRatios:'生産率比率',
GrowthRatios:'成長率',
    Revenue:"収入",
    Profit:"利益",
    Growth:"成長",
    Liquidity:"キャッシュフローの状況",
    FinancialStructure:"財務構造",
    CreditOpinion:"与信意見",
    RiskIndicator:"リスク指標",
    Solvencyindex:"ソルベンシー指数",
    Year:"年",
    Change:"変化",
    Revenue:"収入",
    NetProfit:"純利益",
    TotalAssets:"総資産",
    Equity:"純資産",
    GrossMargin:"粗利率",
    ProfitMargin:"粗利",
    ReturnonEquity:"純資産収益率",
    CurrentRatio:"流動比率",
    DebtRatio:"負債比率",
    FinancialHighlights:"関連会社からの財務データ",
    FinancialHighlightsTitle:"関連会社からの財務概要",
    CompanyName:"会社名",
    CompanyID:"会社ID",
    Country:"国",
    CompanyStatus:"会社状況",
    Relations:"関係",
    RatioAnalysis:"メニュー"
},
IndustryNorms:{
    IndustryStatistics:"業界統計",
    ofcompaniesintheIndustry:"業界内会社数",
    oflistedCompaniesintheIndustry:"業界内上場会社数",
    oflargecompaniesintheIndustry:"業界内大手会社数",
    ofSMEsintheIndustry:"業界内中小会社数",
    ofcompaniesinsample:"サンプル会社数",
    ofcompaniesinloss:"赤字会社数",
    Observations:"観測",
    AverageValue:"平均値",
    MedianValue:"中央値",
    MaximumValue10:"最大値10％",
    MinimumValue10:"最小値10％",
    SubjectCompany:"対象会社",
    YearsinBusiness:"ビジネス年数",
    TotalAssets:"総資産",
    TotalEquity:"総資本",
    Revenue:"収入",
    NetEarning:"純利益",
    Returnonassets:"資産収益率",
    Performance:"パフォーマンス",
    ProfitabilityRatios:"収益率",
    Returnonequity:"純資産収益率",
    Returnonassets:"資産収益率",
    Grossmargin:"粗利率",
    OperatingRatios:"運営比率",
    Stockturnover:"在庫回転率",
    Accountsreceivableturnover:"売掛金回転率",
    Assetsturnover:"資産回転率",
    Totalassetturnover:"総資産回転率",
    StructuralRatios:"構造比率",
    Currentratio:"流動比率",
    Quickratio:"当座比率",
    Shareholdersliquidityratio:"株主流動性比率",
    GrowthRatios:"成長率",
    Salesgrowthrate:"売上成長率",
    Netprofitgrowthrate:"純利益成長率",
    Totalassetsgrowthrate:"総資産成長率"
},
 News:{
  Date:'日付',//日期
  Title:'タイトル',//标题
  Source:'ソース',//来源
  Impact:'インパクト',//影响
  Searchcompanies:'他の会社のニュースを検索する',//国家/地区
},
 Sanctions:{
  Potentialcompliance:'潜在的なコンプライアンスリスクを検出した',//检测到潜在合规风险
  SeachbuttonNo:'この会社には有害的なことを検出しない',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'もっと制裁記録を検索する場合、「制裁検索」ボタンを押す',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
   SearchSanctions:"制裁検索",
    ViewDetails:"詳細表示",
    Sanctions:"制裁",
    Potentialcompliancerisks:"潜在的なコンプライアンスリスク",
    IDInfo:"ID情報",
    IDType:"ID類型",
    IDDescription:"ID説明",
    SanctionList:"制裁リスト",
    SanctionListInvolved:"関連制裁リスト",
    StartDate:"開始日",
    EndDate:"終了日",
    SourceList:"ソースリスト",
    SourceName:"ソース名",
    ProfileNotes:"概要説明",
    Link:"リンク"
},
CreditOpinion:{
    CreditAssessment:"与信評価",
    CreditAssessmentfromtheRelatedCompanies:"関連会社からの与信評価",
    Year:"年",
    CreditRating:"与信レベル",
    LocalCreditScore:"ローカル与信点数",
    ProbabilityofDefault:"違約率",
    SolvencyIndex:"ソルベンシー指数",
    CreditLine:"与信金額",
    RiskIndicator:"リスク指数",
    RelatedCreditAssessment:"関連与信評価",
    CompanyName:"会社名",
    CompanyID:"会社ID",
    Country:"国",
    CompanyStatus:"会社状況",
    Relations:"関係",
    LocalCreditScore:"ローカル与信点数",
    SolvencyIndex:"ソルベンシー指数",
    ProbabilityofDefault:"違約率",
    RiskIndicator:"リスク指数"
},
AccountCenterMenu:{
    SearchinSettings:"条件検索",
    Account:"アカウント",
    MyAccount:"私のアカウント",
    ContactInfo:"連絡先情報",
    AccountSecurity:"アカウントセキュリティ",
    OrganizationalManagement:"組織管理",
    UserGroup:"ユーザグループ",
    User:"ユーザ",
    Role:"役割",
    MyDatabase:"私のデータベース",
    MyUsage:"私の使用",
    CompaniesViewed:"表示した会社",
    ReportsDownloaded:"ダウンロードしたレポート",
    ReportUpdatesOrdered:"要求したレポート更新",
    BillingandPayment:"請求と支払",
    BillRecords:"請求記録",
    PaymentRecords:"支払記録",
    CreditDeductions:"クレジット控除",
    InvoicesDownloaded:"ダウンロードしたインボイス",
    UserSettings:"ユーザ設置",
    Messages:"メッセージ",
    Notifications:"通知",
    HelpCenter:"ヘルプセンター",
    FAQ:"FAQ",
    Privacy:"プライバシー",
    Terms:"条件",
    ReportIssues:"問題報告",
    UserGuide:"ユーザガイド",
    AboutCSI:"CSIについて"


},
RatingAnalysis:{
    IndustyAnalysis:"産業分析",
    GeographicAnalysis:"地理分析",
    CompanyTypeAnalysis:"会社類型分析",
    BiusinessScaleAnalysis:"ビジネス規模分析",
    HistoryAnalysis:"歴史分析",
    NormalDistribution:"正規分布",
    SubjectCompany:"対象会社",
    Probabilityofthesubjectratinginitsindustry:"業界内対象評価率",
    Maximum:"Max 10%",
    Mean:"中央値",
    Average:"平均値",
    Minimum:"Min 10%",
    RatingDistribution:"評価分布",
    Revenue:"収入",
    Earning:"利益",
    TotalAssets:"総資産",
    Subjectratinginitsindustrybyfinancialindicators:"業界内対象財務指標評価",
    Best:"最高",
    Worst:"最低",
    Rankingofsubject:"業界内対象評価ランキング",
    Industy:"産業",
    Percentilerank:"比率ランキング：％対象の会社を超える",
    Historicaldevelopmentofsubject:"業界内対象評価の発展歴史",
    IndustryAverage:"業界平均",
    SubjectRatingChanges:"対象評価変動"
},
CompetitiveAnalysis:{
    MarketPosition:"市場地位",
    Revenus:"収入",
    NetEarnings:"純利益",
    NetAssets:"純資産",
    TotalAssets:"総資産",
    Employees:"従業員",
    Mean:"中央値",
    Average:"平均値",
    Maximum:"Max (10%)",
    Worst:"Worst (10%)",
    Subjectcompany:"対象会社",
    PerformanceComparison:"表現比較",
    ProfitabilityRatios:"収益率",
    Grossmargin:"粗利率",
    Returnonassets:"資産収益率",
    Returnonequity:"純資産収益率",
    Average:"平均値",
    OperatingRatios:"運営比率",
    Stockturnover:"在庫回転率",
    Assetsturnover:"資産回転率",
    Collectionperiod:"回収期間",
    GrowthRatios:"成長率",
    Totalassetsgrowthrate:"総資産成長率",
    Salesgrowthrate:"売上成長率",
    Netprofitgrowthrate:"純利益成長率",
    StructuralRatios:"構造比率",
    Debtratio:"負債比率",
    Quickratio:"当座比率",
    Currentratio:"流動比率"
},
MyAccount:{
    Logintime:"ログイン時間",
    SignOut:"サインアウト",
    DeleteAccount:"アカウント削除",
    AccountID:"アカウントID",
    Enteranewaddress:"新しいメールを入力する",
    EnterVerificationCode:"承認コードを入力する",
    SendverificationCode:"承認コードを発送する",
    Password:"パスワード",
    Originalpassword:"旧いパスワード",
    Newpassword:"新しいパスワード",
    Confirmnewpassword:"新しいパスワードの確認",
    AccountOwnership:"アカウント所有権",
    IndividualAccount:"個人口座",
    GroupAccount:"グループアカウント",
    Organizationname:"組織名",
    CountryRegion:"国/地域",
    Address:"アドレス",
    City:"市",
    ZipCode:"郵便番号",
    FirstName:"名",
    LastName:"姓",
    PhoneNumber:"電話番号",
    Email:"メール",
    Change:"変化",
    Save:"保存",
    Cancel:"取消",
    LastLogin:"最後のログイン",
    RecentLogin:"最近のログイン",
    AverageLoginTime:"平均ログイン時間",
    TotalLoginAttempts:"総ログイン時間"

},
ShippingOrderDetails:{
    Date:"日付",
    MasterBillofLading:"マスター船荷証券",
    Source:"ソース",
    BillNo:"請求書番号",
    ImporterBuyer:"輸入者/購入者",
    ExporterSeller:"輸出車/販売者",
    Name:"名",
    Address:"アドレス",
    Country:"国",
    Contact:"連絡",
    Email:"メール",
    CargoInfo:"貨物情報",
    HSCode:"HSコード",
    Quantity:"数量",
    WeightUnit:"重量単位",
    ProductDescription:"製品説明",
    Amount:"金額",
    QuantityUnit:"数量単位",
    Weight:"重量",
    HSDescription:"HS説明",
    Incoterms:"インコタームズ",
    ShippingInfo:"輸送情報",
    Vessel:"船",
    Consignee:"荷受人",
    MeansofTransport:"輸送方法",
    CountryofOrigin:"出発国",
    Voyage:"航行",
    Notifier:"通知者",
    CountryofDestnation:"目的国",
    AddressofOrigin:"出発地アドレス",
    Shipper:"出荷者",
    AddressofDestnation:"目的地アドレス",
    Container:"コンテナ",
    ContainerID:"コンテナID",
    ContainerType:"コンテナタイプ",
    ContainerDescDode:"コンテナDescコード",
    ContainerSize:"コンテナサイズ"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"どのような問題をご報告しているでしょうか？",
    Tellusmoreaboutyourproblems:"もっと詳しくご説明ください。",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"問題に関するスクリーンショット或はファイルをご提供できるでしょうか？",
    Fillinyourcontactinformation:"連絡先情報を入力する",
    FirstName:"名",
    LastName:"姓",
    PhoneNumber:"電話番号",
    Email:"メール"
},
UserSettings:{
    LanguageandLocation:"言語と位置",
    Language:"言語",
    Selectyourpreferedlanguage:"好きな言語を選択する",
    Location:"位置",
    Selectyourlocation:"あなたの位置を選択する",
    NotificationSetting:"通知設定",
    EmailNotification:"メール通知",
    ServiceUpdates:"サービス更新",
    CompanyNews:"会社ニュース"
},
ContactInfo:{
    ContactInfo:"連絡先情報",
    FirstName:"名",
    LastName:"姓",
    PhoneNumber:"電話番号",
    Email:"メール",
    CountryRegion:"国/地域",
    AddressLine:"アドレスライン",
    City:"市",
    ZipCode:"郵便番号",
    Alternativecontactperson:"緊急連絡先",
    Setascontactperson:"連絡先設定",
    Edit:"編集"
},
AccountSecurity:{
    Setupmysecurityquestions:"セキュリティ質問を設置する",
    Pleasechooseaquestion:"質問をご選択ください",
    Pleaseentertheanswertothequestion:"質問の回答をご選択ください",
    SessionTimeoutAutomaticLogoutSettings:"ログイン　タイムアウト：自動ログアウト設定",
    Thesystemwillautomatically:"一定な時間内何も操作がない場合、自動ログアウトする。デフォルト時間は5分間であり、時間を調整できる。"
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"検索された会社数",
    TotalNumberofCompaniesCollected:"集められた会社数",
    TotalNumberofUpdateReportsOrdered:"オフラインレポート数",
    Date:"日付",
    UserName:"ユーザ名",
    CompanyName:"会社名",
    Status:"状況",
    UsageType:"使用類型",
    Entercompanyname:"会社名を入力する",
    Download:"ダウンロード"
},
OrganizationalManagement:{
   GroupName:"グループ名",
    ParentGroupName:"親グループ名",
    Organization:"組織",
    GroupID:"グループ名番号",
    GroupStatus:"グループ状況",
    Operation:"操作",
    NewlyBuilt:"新規",
    UserAccount:"ユーザアカウント",
    Role:"役割",
    AccountStatus:"アカウント状況",
    RoleName:"役割名",
    Position:"職位",
    RoleStatus:"役割状況",
    Valid:"有効",
    Invalid:"無効",
    PermissionSettings:"許可設定"
},
BillingandPayment:{
    TotalNumberofOrders:"注文合計数",
    TotalPaymentAmount:"支払総金額",
    TotalDeductionCredits:"クレジット控除合計数",
    Date:"日付",
    UserAccount:"ユーザアカウント",
    CompanyName:"会社名",
    OrderNo:"注文番号",
    OrderType:"注文種類",
    OrderStatus:"注文状況",
    Download:"ダウンロード",
    PaymentAmount:"支払金額",
    Contactus:"お問い合わせ",
    DownloadInvoice:"インボイスをダウンロードする",
    CreditsDeducted:"クレジット控除",
    ReportOrderStatus:"注文状況を報告する",
    CompanyID:"会社ID",
    CountryRegion:"国/地域",
    AddressLine:"アドレスライン",
    City:"市",
    ZipCode:"郵便番号",
    FirstName:"名",
    LastName:"姓",
    PhoneNumber:"電話番号",
    Email:"メール",
    BankAccountHolderName:"銀行口座保有者名",
    BeneficiaryBankName:"受益者銀行名",
    SWIFTCODE:"SWIFTコード",
    AccountNumber:"アカウント番号",
    BeneficiaryBankAddress:"受益者銀行アドレス",
    ABA:"ABA(ルーティング番号)",
    IBANnumber:"IBAN番号"
},
JiuGuoge:{
  Country:'国',
  Industry:'業界',
  CoSize:'会社規模',
  Liquidity:'キャッシュ・フロー・ステータス',
  NoofcoinIndustry:'会社業界番号',
  IndustryRating:'業界評価',
  Profitability:'収益性',
  Growth:'成長率',
  FinancialStructurt:'財務構造',
  Repaying:'返済能力',
},
  ...jaLocale
}

export default jp